import React from "react";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { withLink, withRouterLink } from "./LinkHOC.js";
function TextLinkInternal({ title }) {
  return /* @__PURE__ */ React.createElement(LocalizedText, { label: title });
}
const LinkText = withLink(TextLinkInternal, true);
const RouterLinkText = withRouterLink(LinkText);
export {
  LinkText,
  RouterLinkText
};
//# sourceMappingURL=LinkText.js.map
